<template>
    <div>
        <div class="mt-3 mb-1">
            <strong>Your Score</strong>
            <p>
                Please vote 1-5 (5 being the highest score) below.
                Entries are judged on their own merit and do not compete against each other.
            </p>

            <ul class="my-2 ml-4">
                <li>5 = Definitely Worthy</li>
                <li>4 = Worthy</li>
                <li>3 = Potentially Worthy</li>
                <li>2 = Likely Not Worthy</li>
                <li>1 = Not Worthy</li>
            </ul>

            <div>

                <div class="score-wrapper my-4">
                    <div class="label label-small mb-0">Score</div>
                    <RadioButtonGroup name="score" v-model="score" :options="scoreOptions" />
                    <div class="label label-small font-italic">Select a number</div>
                </div>

                <p class="small greyed-light my-2">By clicking SUBMIT you confirm that you watched 50% or more of the videos submitted.</p>

                <button @click.prevent="confirmVotesModal = true" type="submit" class="btn w-100" :disabled="!scoreFormValid">
                    <checkmark></checkmark>
                    Submit
                </button>
            </div>

            <br />
            <br />

            <div v-if="skipsRemaining > 0">
                <button @click.prevent="skipVoteModal = true" type="submit" class="btn-link">Skip this entry</button>
            </div>
            <div class="small greyed-light mt-2">
                <template v-if="skipsRemaining >= skipsMaximum">
                    You have a total of {{skipsMaximum}} skips.
                </template>
                <template v-else-if="skipsRemaining > 1">
                    You have {{skipsRemaining}} skips remaining.
                </template>
                <template v-else-if="skipsRemaining > 0">
                    You have {{skipsRemaining}} skip remaining.
                </template>
                <template v-else>
                    You have no skips remaining.
                </template>
            </div>
        </div>

        <modal v-if="confirmVotesModal" @close="confirmVotesModal = false">
            <h1 class="text-center w-100 mb-0" slot="header">
                <template v-if="!savingData">Submit Vote</template>
                <template v-else>Saving</template>
            </h1>
            <div class="content text-center py-2 modal-body-restrict" slot="body">
                <div v-if="!savingData">
                    <p>I am ready to submit my vote and understand that I will not be able to print, alter, or rescind my vote once I have done so.</p>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>
            </div>
            <div class="form-group-submit" slot="footer">
                <div v-if="!savingData">
                    <button class="btn btn-primary pull-left" @click="confirmVotesModal = false">
                        <close-icon></close-icon>
                        Cancel
                    </button>
                    <button class="btn btn-primary pull-right" @click.prevent="submitVotes">
                        <checkmark></checkmark>
                        Submit
                    </button>
                </div>
            </div>
        </modal>

        <modal v-if="successModal" :showHeader="false" :showFooter="false">
            <div class="content" slot="body">
                <div v-html="success_html">

                </div>
            </div>
        </modal>

        <modal v-if="skipVoteModal">
            <h1 class="text-center w-100 mb-0" slot="header">Skip this entry</h1>
            <div class="content text-center py-2 modal-body-restrict" slot="body">
                <p>Are you sure you want to skip this entry?
                    <template v-if="skipsRemaining > 1">
                        You have {{skipsRemaining}} skips remaining.
                    </template>
                    <template v-else-if="skipsRemaining > 0">
                        You have {{skipsRemaining}} skip remaining.
                    </template>
                    <template v-else>
                        You have no skips remaining.
                    </template>
                </p>
                <p>Once you skip this entry, you will not be able to vote on it.</p>
            </div>
            <div class="form-group-submit" slot="footer">
                <button class="btn btn-primary pull-left" @click="skipVoteModal = false">
                    <close-icon></close-icon>
                    Close
                </button>
                <button class="btn btn-primary pull-right" @click.prevent="submitSkip">
                    <fast-forward></fast-forward>
                    Skip
                </button>
            </div>
        </modal>

    </div>
</template>

<script>
    import caretleft from './icons/caret_left.vue';
    import caretright from './icons/caret_right.vue';
    import play from './icons/play.vue';
    import RadioButtonGroup from "./RadioButtonGroup.vue";
    import Checkmark from "../Icons/checkmark.vue";
    import CloseIcon from "../Icons/close.vue";
    import FastForward from "../Icons/FastForward.vue";
    import Modal from "./Modal.vue";
    import spinner from "./icons/spinner.vue";

export default {
    name: "EntryJudgingFormScored",
    components: {Modal, Checkmark, CloseIcon, FastForward, RadioButtonGroup, spinner},
    props: ['submitScoreUrl', 'skipUrl', 'skipsMaximum', 'skipsRemaining'],
    data() {
        return {
            score: null,
            scoreOptions: [1, 2, 3, 4, 5].map(score => {
                return {
                    value: score,
                    label: score
                };
            }),
            confirmVotesModal: false,
            savingData: false,
            successModal: false,
            skipVoteModal: false,
            success_html: '',
        }
    },
    computed: {
        scoreFormValid() {
            return this.score !== null && this.score >= 1 && this.score <= 5;
        }
    },
    mounted() {
    },
    methods: {
        submitVotes() {
            this.savingData = true;
            window.axios.post(this.submitScoreUrl, {
                score: this.score
            }).then(response => {
                this.savingData = false;
                this.confirmVotesModal = false;
                this.successModal = true;
                this.success_html = response.data.success_html;
            }).catch(error => {
                this.savingData = false;
                this.confirmVotesModal = false;
                let errorMessage = {
                    'level': 'danger',
                    'message': error.response.data.message
                };
                this.$emit('judgingErrorMessage', errorMessage);
            });
        },
        submitSkip() {
            this.savingData = true;
            window.axios.post(this.skipUrl).then(response => {
                this.savingData = false;
                if(response.data.success == 'done') {
                    window.location.href = '/judging';
                } else {
                    window.location.href = response.data.redirect_url
                }
            }).catch(error => {
                this.skipVoteModal = false;
                let errorMessage = {
                    'level': 'danger',
                    'message': error.response.data.message
                };
                this.$emit('judgingErrorMessage', errorMessage);
            });
        }
    },
}
</script>
<style lang="scss">

</style>
